import { Route } from "@angular/router";
import { ResetPasswordConfirmComponent } from "./reset-password-confirm.component";

export const ResetPasswordConfirmRouting: Route = {
    path: 'reset-password-confirm', component: ResetPasswordConfirmComponent 
};